import { Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useNavigate } from 'react-router-dom'

import {
  useStocksServiceGetFormListEndpoint,
  useStocksServiceGetInternationalNameListEndpoint,
  useStocksServiceGetProducerListEndpoint,
  useStocksServiceGetMedicineListEndpoint,
  useStocksServiceGetMeasurementUnitListEndpoint,
  useStocksServiceGetConsumableListEndpoint
} from 'src/api/queries'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

const { Link } = Typography

export const useTableConfig = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const { data: medicines } = useStocksServiceGetMedicineListEndpoint({})

  const { data: internationalNames } =
    useStocksServiceGetInternationalNameListEndpoint({})

  const { data: pharmaceuticalForms } = useStocksServiceGetFormListEndpoint({})

  const { data: producers } = useStocksServiceGetProducerListEndpoint({})

  const { data: units } = useStocksServiceGetMeasurementUnitListEndpoint({})

  const { data: consumables } = useStocksServiceGetConsumableListEndpoint({})

  const columns: ColumnsType = [
    {
      key: 'title',
      title: t('classifiers.title'),
      dataIndex: 'title',
      width: 300
    },
    {
      key: 'description',
      title: t('classifiers.description'),
      dataIndex: 'description'
    },
    {
      key: 'count',
      title: t('medicine_register.count'),
      dataIndex: 'count',
      width: 170
    },
    {
      key: 'details',
      align: 'center',
      width: 103,
      render: ({ path }: { path: string }) => (
        <Link onClick={() => navigate(path)}>{t('common.details')}</Link>
      )
    }
  ]

  const dataSource = [
    {
      title: t('medicine_register.products.title'),
      description: t('medicine_register.products.description'),
      path: paths.medicinesRegister.products.root,
      count: medicines?.totalCount ?? 0
    },
    {
      title: t('medicine_register.international_name.title'),
      description: t('medicine_register.international_name.description'),
      path: paths.medicinesRegister.internationalNames,
      count: internationalNames?.totalCount ?? 0
    },
    {
      title: t('medicine_register.pharmaceutical_form.title'),
      description: t('medicine_register.pharmaceutical_form.description'),
      path: paths.medicinesRegister.pharmaceuticalForms,
      count: pharmaceuticalForms?.totalCount ?? 0
    },
    {
      title: t('medicine_register.producers.title'),
      description: t('medicine_register.producers.description'),
      path: paths.medicinesRegister.producers,
      count: producers?.totalCount ?? 0
    },
    {
      title: t('medicine_register.units.title'),
      description: t('medicine_register.units.title'),
      path: paths.medicinesRegister.units,
      count: units?.totalCount ?? 0
    },
    {
      title: t('common.pharmaceutics'),
      description: t('common.pharmaceutics'),
      path: paths.medicinesRegister.consumables.root,
      count: consumables?.totalCount ?? 0
    }
  ]

  return { columns, dataSource }
}
